import { render, staticRenderFns } from "./Igrejas.vue?vue&type=template&id=c7c774de"
import script from "./Igrejas.vue?vue&type=script&lang=js"
export * from "./Igrejas.vue?vue&type=script&lang=js"
import style0 from "./Igrejas.vue?vue&type=style&index=0&id=c7c774de&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports